import { api } from "./api-core";

export interface ITwinSpace {
  user_quota: number;
  user_storage: number;
  percent: string;
  max_room: number;
  user_room: IUserRoom;
  user_avatar: IUserAvatar;
  list_room_publish: IRoomPublish;
}

export interface IUserRoom {
  data: {
    entry_mode: string;
    hub_sid: string;
    inserted_at: string;
    max_occupant_count: number;
    name: string;
    thumbnail_url: string;
    updated_at: string;
    username: string;
    visit_count: number;
  }[];
  page: number;
  page_size: number;
  total_page: number;
  total_rows: number;
}

export interface IUserAvatar {
  data: {
    avatar_id: string;
    avatar_sid: string;
    content_length: string;
    content_type: string;
    inserted_at: string;
    name: string;
    owned_file_uuid: string;
    slug: string;
    thumbnail_url: string;
    updated_at: string;
  }[];
  page: number;
  page_size: number;
  total_page: number;
  total_rows: number;
}
export interface IRoomPublish {
  data: {
    entry_mode: string;
    hub_sid: string;
    inserted_at: string;
    max_occupant_count: number;
    name: string;
    thumbnail_url: string;
    updated_at: string;
    username: string;
    visit_count: number;
  }[];
  page: number;
  page_size: number;
  total_page: number;
  total_rows: number;
}

export const MyTwinSpaceApi = {
  getMyTwinSpace: () => {
    return api
      .get(process.env.API_GET_MY_TWINSPACE as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  removeRoom: (data: { room_id?: string }) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
            // Xử lý các trường đơn
            formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_REMOVE_ROOM;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error in storePartner:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
};
